export default "__VITE_ASSET__BhifMy58__"